<span class="preamble">
  <% var selectedTime = moment.parseZone(selectedDate).format(I18n.moment_time_format) %>
  <% var selectedDay = Sparkle.Utilities.appointmentDate(moment.parseZone(selectedDate), AppointmentBooking.config.slot_show_year, 'MMMM D', 'MMMM D, YYYY') %>
  <% if (slots.length == 1) { %>
    <%= I18n.confirmation_modal.confirm_preamble_html.replace('%{provider}', slots[0].provider.name).replace('%{time}', selectedTime).replace('%{date}', selectedDay) %>
  <% } else { %>
    <%= I18n.confirmation_modal.choose_preamble_html.replace('%{time}', selectedTime).replace('%{date}', selectedDay) %>
  <% } %>
</span>

<div class="slots">
  <% slots.forEach(function(slot){ %>
    <div class="slot sp-provider-card" >
      <div class="provider-container" data-provider-id="<%= slot.provider.id%>"></div>
      <div class="sp-provider-card__actions">
        <sp-button variant="outlined" class="confirm-button" data-slot-id="<%= slot.id %>">
          <% if (slots.length == 1) { %>
            <%= I18n.confirmation_modal.confirm %>
          <% } else { %>
            <%= I18n.confirmation_modal.choose %>
          <% } %>
          </div>
      </sp-button>
      </div>
  <% }) %>
</div>
